import { Divider } from '@material-ui/core'
import { addDays, getDate, subDays } from 'date-fns'
import React from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import DateFormatter from '../DateFormatter'
import { IDayPickerDispatch, IDayPickerProps } from './DayPicker'
import { Day, DayOfWeek, IconButton, Picker, WeekDays } from './styled'

function DayPickerSized({
  date,
  change,
}: IDayPickerProps & IDayPickerDispatch) {
  function moveForward() {
    change(addDays(date, 1))
  }

  function moveBackward() {
    change(subDays(date, 1))
  }

  return (
    <React.Fragment>
      <Picker days={true} style={{ height: '100px' }}>
        <IconButton
          style={{ lineHeight: '100px' }}
          onClick={moveBackward}
          left={true}
        >
          <FiChevronLeft />
        </IconButton>
        <IconButton
          style={{ lineHeight: '100px' }}
          onClick={moveForward}
          right={true}
        >
          <FiChevronRight />
        </IconButton>
        <WeekDays>
          <Day sized={true}>
            {getDate(date)}
            <DayOfWeek>
              <DateFormatter date={date} dateFormat={'dddd'} />
            </DayOfWeek>
          </Day>
        </WeekDays>
      </Picker>
      <Divider />
    </React.Fragment>
  )
}

export default DayPickerSized
